import CTModal from '../helpers/CTModal';
import React, { Component, PropTypes } from 'react';
import Message from '../message/Message';

export default class UnsavedChangesModal extends Component {
    render() {
        const { chain, hotel, level, titleName = '', onClose, onPrimaryClick, onSecondaryClick } = this.props;
        const propertyInfo =
            level === 'hotel'
                ? {
                      id: hotel,
                      type: 'Hotel'
                  }
                : {
                      id: chain,
                      type: 'Chain'
                  };

        return (
            <CTModal
                open
                onClose={onClose}
                primaryButton
                primaryButtonClick={onPrimaryClick}
                primaryButtonTitle="Yes, Continue"
                secondaryButton
                secondaryButtonClick={onSecondaryClick}
                secondaryButtonTitle="No, Go Back"
                className="col-md-6"
            >
                <Message
                    noBorder
                    messagePanelClassName="spark-pad-0"
                    sizeClassName="spark-message--xl"
                    heading={`Unsaved changes exist for Property ${propertyInfo.id} ${propertyInfo.type} ${titleName}`}
                    body="Any unsaved changes will be lost. Do you want to continue anyway?"
                    size="xl"
                    type="error"
                />
            </CTModal>
        );
    }
}

UnsavedChangesModal.propTypes = {
    chain: PropTypes.string,
    hotel: PropTypes.string,
    level: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onPrimaryClick: PropTypes.func.isRequired,
    onSecondaryClick: PropTypes.func.isRequired
};

UnsavedChangesModal.defaultProps = {
    chain: '',
    hotel: '',
    level: ''
};



// WEBPACK FOOTER //
// ./src/components/modals/UnsavedChangesModal.js